import type { Mutation } from 'vuex'
import type { CartDocument, CartRecipient, State } from './state'

import actionTypes from './actionTypes'
import { RecipientOption } from '@/api/send_cart/model/sendCartModel'

const mutations: { [actionTypes: string]: Mutation<State> } = {
  [actionTypes.SET_DETAIL]: (state: State, item: any) => {
    state.detail = { ...item }
  },

  [actionTypes.SET_SENDABLE_STATUS](state, status: boolean): void {
    state.sendable = status
  },

  [actionTypes.SET_SENDABLE_CHECKED_MESSAGE](state, message: string): void {
    state.sendableCheckedMessage = message
  },

  //送信先選択
  [actionTypes.SET_RECIPIENT_OPTIONS]: (state: State, options: RecipientOption[]) => {
    state.recipientOptions = [...options]
  },
  //sideBar
  [actionTypes.SET_SIDEBAR_CLICK]: (state: State, status: string) => {
    state.sideBarClick = status
  },

  [actionTypes.SET_ALLOW_MOVE_TO_CONFIRM_VIEW](state, status: boolean): void {
    state.allowMoveToConfirmView = status
  },
}

export default mutations
